import { z } from 'zod';
import { AllergenSchema } from '../domain/food.js';

export const AiProviderKindSchema = z.enum([
  'gemini_flash',
  'gemini_pro',
  'openai_gpt4o',
  'claude_sonnet',
]);
export type AiProviderKind = z.infer<typeof AiProviderKindSchema>;

export const InvoiceExtractionSchema = z.object({
  supplier: z.object({
    piva: z.string().nullable(),
    codice_fiscale: z.string().nullable(),
    name: z.string().nullable(),
  }),
  document: z.object({
    number: z.string().nullable(),
    date: z.string().nullable(),
    total_amount: z.number().nullable(),
    type: z.enum(['fattura', 'ddt', 'nota_credito', 'nota_debito', 'autofattura']).nullable(),
    currency: z.string().default('EUR'),
  }),
  lines: z.array(
    z.object({
      description: z.string(),
      qty: z.number().nullable(),
      uom: z.string().nullable(),
      unit_price: z.number().nullable(),
      batch_lot: z.string().nullable(),
      expiration_date: z.string().nullable(),
    }),
  ),
  confidence: z.number().min(0).max(1),
});
export type InvoiceExtraction = z.infer<typeof InvoiceExtractionSchema>;

export const FoodPackageExtractionSchema = z.object({
  name: z.string().nullable(),
  brand: z.string().nullable(),
  allergens: z.array(AllergenSchema),
  ingredients: z.array(z.string()),
  net_weight_g: z.number().nullable(),
  expiration_date: z.string().nullable(),
  batch_lot: z.string().nullable(),
  storage_instructions: z.string().nullable(),
  confidence: z.number().min(0).max(1),
});
export type FoodPackageExtraction = z.infer<typeof FoodPackageExtractionSchema>;

export interface AiVisionProvider {
  readonly kind: AiProviderKind;
  // T-170 1c: accetta 1 o N immagini (pagine dello STESSO documento). Le impl
  // normalizzano a array. Retrocompat: i caller single-image passano una stringa.
  extractInvoice(images: string | string[], hint?: { supplier_hint?: string }): Promise<InvoiceExtraction>;
  extractFoodPackage(imageB64: string): Promise<FoodPackageExtraction>;
  ocrRaw(imageB64: string): Promise<string>;
}
